import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AdminAuthProvider } from "@/context/AdminAuth";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Landing from "@/pages/Landing";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Projects from "@/pages/Projects";
import RequestForm from "@/pages/RequestForm";
import Contact from "@/pages/Contact";
import Confirmation from "@/pages/Confirmation";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App min-h-screen bg-[#f8f9f8] font-sans text-[#1a221e]">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/request" element={<RequestForm />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/confirmation/:ref" element={<Confirmation />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <WhatsAppButton />
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
